import { HttpErrorResponse } from '@angular/common/http';
import { consoleHelper } from 'lib/helpers/console-helper.class.js';
import { Observable, RetryConfig, retry, timer } from 'rxjs';

export function backoffRetry<T>(url: string, retryConfig: RetryConfig): (obs: Observable<T>) => Observable<T> {
	return (obs$: Observable<T>) =>
		obs$.pipe(
			retry({
				count: retryConfig.count,
				delay: (error, retryIndex) => {
					if (!canRetryError(error)) {
						// throw error if error cannot be retried
						throw error;
					}
					const waitTime = Math.pow(2, retryIndex - 1) * (retryConfig.delay ? +retryConfig.delay : 0);
					consoleHelper.logToConsole({
						type: 'Warning',
						message: `Retry attempt ${retryIndex.toString()} for '${url}'. Wait for '${waitTime}ms'`
					});
					return timer(waitTime);
				}
			})
		);
}

function canRetryError(error: any): boolean {
	if (error instanceof HttpErrorResponse) {
		if (error.status >= 400 && error.status < 500) {
			return false;
		}
	}

	return true;
}
